// Log messages and exceptions to Azure Application Insights

import { SeverityLevel } from "@microsoft/applicationinsights-common";
import { appInsights } from "./appInsights";

export const info = (message) => {
  let obj = {
    message: message,
    severityLevel: SeverityLevel.Information,
  };

  appInsights.trackTrace(obj);
};

export const warning = (message) => {
  let obj = {
    message: message,
    severityLevel: SeverityLevel.Warning,
  };

  appInsights.trackTrace(obj);
};

export const error = (message) => {
  let obj = {
    error: new Error(message),
    severityLevel: SeverityLevel.Error,
  };

  appInsights.trackException(obj);
  console.error(message);
};

export const exception = (exception) => {
  const ex = {
    exception,
    severityLevel: SeverityLevel.Error,
  };
  appInsights.trackException(ex);
  console.error(exception);
};

export const event = (name, properties) => {
  let obj = {
    name,
    properties,
  };

  appInsights.trackEvent(obj);
};

// Add custom column to all telemetry sent to App Insights
export const setConversationIdTelemetryField = (conversationId) => {
  var telemetryInitializer = (envelope) => {
    envelope.data.conversationId = conversationId;
  };
  appInsights.addTelemetryInitializer(telemetryInitializer);

  console.log(
    `Custom App Insights field conversationId set to '${conversationId}'`
  );
};
